export const ROOM_TYPES = {
    ONE_BEDROOM: '1 Bedroom',
    TWO_BEDROOM: '2 Bedroom',
    THREE_BEDROOM: '3 Bedroom',
    ANY: 'Any',
}